export function getStrapiMedia(url?: string) {
  if (url == null) {
    return ''
  }

  // S3 provider
  if (url.startsWith('http')) {
    return url
  }

  return `${
    process.env.NEXT_PUBLIC_STRAPI_API_URL ?? 'http://localhost:1337'
  }${url}`
}
